import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[alert-func]'
})
export class AlertFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}